<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="80%" max-width="800px" @click:outside="onClose">
      <v-card class="px-10 py-5 branch-modal-border">
        <v-btn icon style="position: absolute; top: 5px; right: 5px;" @click="onClose">
          <v-icon small color="#2e8037">mdi-close</v-icon>
        </v-btn>
        <p class="sub-header1 text-tcdc-green">miniTCDC</p>

        <v-row>
          <template v-for="(zones, index) of items">
            <v-col :key="index.toString()" class="d-flex flex-column" cols="6" md="3">
              <span class="text-tcdc-green">{{ zones.zone }}</span>
              <template v-for="(item, index) of zones.list">
                <span
                  :key="index.toString()"
                  class="bold text-branch-modal-highlight cursor-pointer"
                  @click="selectItem(item.name)"
                >{{ item.name }}</span>
              </template>
            </v-col>
          </template>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed:{
    ...mapState({
      form : state=>{
        return state.About.form;
      }
    }),
  },
  created() {
    this.items.forEach(item=>{
      let list = [];
      this.form.branch.mini_branch.forEach(mini=>{
        if(mini.zone == item.zone_id){
          list.push({name : mini.branch_name})
        }
      })
      item.list = list;
    })

  },
  data: () => ({
    dialog: false,
    items: [
      {
        zone: "ภาคเหนือ",
        zone_id : 1,
        list: []
      },
      {
        zone: "ภาคตะวันออกเฉียงเหนือ",
        zone_id : 2,
        list: []
      },
      {
        zone: "ภาคตะวันตก",
        zone_id : 3,
        list: []
      },
      {
        zone: "ภาคกลาง",
        zone_id : 4,
        list: []
      },
      {
        zone: "ภาคตะวันออก",
        zone_id : 5,
        list: []
      },
      {
        zone: "ภาคใต้",
        zone_id : 6,
        list: []
      }
    ]
  }),
  methods: {
    onClose() {
      this.$emit("onClose");
    },
    selectItem(name) {
      this.$emit("onSelect", name);
    }
  }
};
</script>

<style lang="scss" scoped>
.branch-modal-border {
  border: 2px solid $tcdcGreen;
}
.text-branch-modal-highlight:hover {
  color: $tcdcGreen !important;
}
</style>
